import {
  CityServiceClient
} from "@/proto/city_grpc_web_pb";
import { 
  City, 
  ListCityRequest,
  ItemCityRequest,
  CityFilter,
  CitySort,
  CityPagination,
  CreateCityRequest,  
  UpdateCityRequest, 
  DeleteCityRequest
} from "@/proto/city_pb";
import {handleRefreshToken} from '@/main'

// Количество на странице по-умолчанию
const defaultLimit:number = 100;

export class CityApi {
  items: Array<City> = [];
  client: CityServiceClient;

  constructor() {
    const host:string = (window as any).VUE_APP_API_URL ?? '';
    this.client = new CityServiceClient(host, null, null);
  }

  getAuth(){
    const metadata: any = {
      Authorization: localStorage.getItem('accessToken')
    }
    return metadata
  }

  // Установка и получение фильтров
  createFilter(data: any){

    const filter = new CityFilter();
    const cityId:number = data.cityId !== undefined ? parseInt(data.cityId) : 0;
    const cityName:string = data.cityName !== undefined ? data.cityName.toString() : "";

    // Устанавливаем фильтры
    filter.setCityId(cityId);
    filter.setCityName(cityName);

    return filter;
  }

  // Установка и получение сортировки
  createSort(data: any){

    const sort = new CitySort();
    const name:string = data.name !== undefined ? data.name.toString() : "city_name";
    const exp:string = data.exp !== undefined ? data.exp.toString() : "asc";

    // Устанавливаем параметры сортировки
    sort.setName(name);
    sort.setExp(exp);

    return sort;
  }

  // Установка и получение пагинации
  createPagination(data: any){

    const pagination = new CityPagination();
    const page:number = data.page !== undefined ? Number(data.page) : 1;
    const limit:number = data.limit !== undefined ? Number(data.limit) : defaultLimit;

    // Устанавливаем пагинацию
    pagination.setPage(page);
    pagination.setLimit(limit);
    pagination.setPages(0);

    return pagination;
  }

  // Список элементов
  getCityItems(filter: any, sort: any, pagination: any){

    const request = new ListCityRequest();
    
    // Устанавливаем параметры запроса
    request.setFilter(this.createFilter(filter));
    request.setSort(this.createSort(sort));
    request.setPagination(this.createPagination(pagination));

    return new Promise((resolve, reject) => {
      this.client.listCity(request, this.getAuth(), (err, message) => {
        if (err) {
          handleRefreshToken()
          reject(err)
        } else {
          resolve(message.getItemsList());
        }
      });
    });
  }

  // Получение элемента
  getCityItem(filter: any){

    const request = new ItemCityRequest();

    // Устанавливаем параметры запроса
    request.setFilter(this.createFilter(filter));

    return new Promise((resolve, reject) => {
      this.client.itemCity(request, this.getAuth(), (err, message) => {
        if (err) {
          handleRefreshToken()
          reject(err)
        } else {
          resolve(message.getItem());
        }
      });
    });
  }

  // Создание элемента
  createCityItem(data: any){

    const request = new CreateCityRequest();
    request.setCityId(data.cityId);
    request.setCityName(data.cityName);

    return new Promise((resolve, reject) => {
      this.client.createCity(request, this.getAuth(), (err, message) => {
        if (err) {
          handleRefreshToken()
          reject(err)
        } else {
          resolve(message);
        }
      });
    });
  }

  // Редактирование элемента
  updateCityItem(data: any){

    const request = new UpdateCityRequest();
    request.setCityId(data.cityId);
    request.setCityName(data.cityName);

    return new Promise((resolve, reject) => {
      this.client.updateCity(request, this.getAuth(), (err, message) => {
        if (err) {
          handleRefreshToken()
          reject(err);
        } else {
          resolve(message);
        }
      });
    });
  }

  // Удаление элемента
  deleteCityItem(data: any){

    const request = new DeleteCityRequest();
    request.setCityId(data.cityId);

    return new Promise((resolve, reject) => {
      this.client.deleteCity(request, this.getAuth(), (err, message) => {
        if (err) {
          handleRefreshToken()
          reject(err);
        } else {
          resolve(message);
        }
      });
    });
  }
}